import React, { useState } from 'react';

import LivePage from './LivePage';
import _ from 'lodash';
import ImageAnnotationsEditor from '../components/images/ImageAnnotationsEditor';

export default class TestPage extends LivePage {
  constructor(props) {
    super(props);

    const sampleAnnotations = [
      { id: 'carBox',
        "type": "boundingBox",
        "left": 0.05401684359183356,
        "top": 0.45557562384545525,
        "width": 0.8764704007024827,
        "height": 0.5373767011370797
      },
    ];

    this.state = {
      ...this.state,
      annotations: sampleAnnotations,
    };

    this.fullScreen = true;
    this.menu = [];
    this.submenu = [];
  }

  handleAnnotationChange = (obj) => {
    this.setState({ annotations: obj.annotations });  
  }

  renderPageBody() {
    const url = 'https://build.ford.com/dig/Ford/F-150%20F-150/2024/HD-FULL/Image%5B%7CFord%7CF-150%20F-150%7C2024%7C1%7C1.%7C801A..145.PUM..88R.89B.SS5.573.BSHDF.BY1AM.CCAB.64B.AWD.998.67T.50M.77R.%5D/EXT/5/vehicle.png';
    const url2 = 'https://tmnaassetscs.scene7.com/is/image/tmnaassetscs/vcr/live/vehicle/TOY/2025/tacoma/7568/632/f6b1ecd0c7c4b610ddf1ccd81443b8acd7d75b60a1099148d5885b70a9291218.png?wid=3200&fmt=webp-alpha&cropN=0.04,0.08,0.92,.84'
    const { annotations } = this.state;
    return <div className={'margin'}>
      <h2>Image Annotations Editor Test</h2>

      <div className="d-flex">

        <div style={{ width: '100%', height: '600px', border: '1px solid #ccc' }}>
          <ImageAnnotationsEditor
            value={{ url: url2, annotations }}
            onChange={this.handleAnnotationChange}
          />
        </div>
        <div className="mt-3">
          <pre>{JSON.stringify(this.state.annotations, null, 2)}</pre>
        </div>
      </div>
    </div>;
  }
}
